


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getProjectSalesReport,
  getProjectSummary,
  getProjectMonths,
  getSalesReportCSV,
  GetProjectSalesReportQuery
} from "../../api/sales-report-api";
import SalesReportSales from "../components/SalesReportSales.vue";
import SalesReportMonthlyChart from "../components/SalesReportMonthlyChart.vue";
import SalesReportMonthlySummary from "../components/SalesReportMonthlySummary.vue";
import ExpensesGraphSaleReport from "../components/ExpensesGraphSaleReport.vue";
import SalesReportNewTables from "../components/SalesReportNewTables.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import VIconPrev from "../components/VIconPrev.vue";
import VIconNext from "../components/VIconNext.vue";
import SalesSummaryNew from "../components/SalesSummaryNew.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { Company, getVendorsForPurchase } from "@/api/company-api";
import { debounce } from "lodash";
import CustomValueDisplay from "@/common/ui/components/CustomValueDisplay.vue";

@Component({
  components: {
    VToolbar,
    VIconPrev,
    VIconNext,
    SalesSummaryNew,
    SalesReportMonthlyChart,
    SalesReportMonthlySummary,
    SalesReportSales,
    ExpensesGraphSaleReport,
    SalesReportNewTables,
    CustomValueDisplay
  }
})
export default class SalesReportProjectPage extends Vue {
  @Prop() projectId?: string;

  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  monthOptions: SelectOption[] = [{ text: "全ての期間", value: "" }];
  vendorOptions: SelectOption[] = [{ text: "全ての発注先", value: "" }];

  data = {
    project: null as any,
    estimates: [] as any[],
    purchases: [] as any[],
    invoices: [] as any[],
    performance: {} as any
  };

  report = {} as any;

  taxExcluded: boolean = false;
  graphOption = "1";
  graphOptions = [
    { text: "発注金額", value: "1" },
    { text: "利益額", value: "2" },
    { text: "利益率", value: "3" }
  ];
  graphFormatter = 1;
  showVendor: boolean = false;
  vendorName: string = "";

  query: GetProjectSalesReportQuery = {
    month: "",
    monthOptions: "",
    vendorId: ""
  };

  protected async created() {
    await this.initProjectMonths();
    await this.initVendorList();

    await this.searchGraph();
    await this.getProjectSummary();
  }

  search = debounce(async () => {
    await this.searchGraph();
  }, 500);

  monthLabel = "";
  monthIndex = 0;
  monthLabelOptions = [] as any[];

  private async searchGraph() {
    this.showVendor = false;
    this.vendorName = "";
    if (this.query.vendorId) {
      const result = this.vendorOptions.find(
        item => item.value === this.query.vendorId
      );
      if (result) {
        this.showVendor = true;
        this.vendorName = result.text;
      }
    }
    this.taxExcluded = false;
    this.graphOption = "1";
    const report = await getProjectSalesReport({
      ...this.query,
      month: this.monthLabelOptions[this.monthIndex].value,
      projectId: this.projectId
    });
    this.report = report;
  }

  private async initProjectMonths() {
    const monthsData = await getProjectMonths({ projectId: this.projectId });

    const defaultLabel = monthsData.default_label;
    this.monthLabel = defaultLabel;
    this.monthLabelOptions.push({ value: "", label: defaultLabel });
    monthsData.month_options.forEach((option: any) => {
      this.monthLabelOptions.push(option);
    });

    // Init monthOptions
    const defaultMonthOptions: SelectOption[] = [
      { text: "1ヶ月間", value: "1" },
      { text: "2ヶ月間", value: "2" },
      { text: "3ヶ月間", value: "3" },
      { text: "4ヶ月間", value: "4" },
      { text: "5ヶ月間", value: "5" },
      { text: "6ヶ月間", value: "6" },
      { text: "7ヶ月間", value: "7" },
      { text: "8ヶ月間", value: "8" },
      { text: "9ヶ月間", value: "9" },
      { text: "10ヶ月間", value: "10" },
      { text: "11ヶ月間", value: "11" },
      { text: "12ヶ月間", value: "12" }
    ];
    defaultMonthOptions.forEach(option => {
      if (parseInt(option.value) <= monthsData.month_options.length) {
        this.monthOptions.push(option);
      }
    });
  }

  private async getProjectSummary() {
    this.data = await getProjectSummary({ projectId: this.projectId });
  }

  private async initVendorList() {
    const vendors = await getVendorsForPurchase(Number(this.projectId));
    vendors.map((v: Company) =>
      this.vendorOptions.push({
        text: v.name,
        value: String(v.office.officeId)
      })
    );
  }

  get reportSummary() {
    if (this.report.summary) {
      return this.taxExcluded
        ? this.report.summary.excludedTax
        : this.report.summary.includedTax;
    }
    return {};
  }

  get expenseCategoriesLabel() {
    if (this.report.expenses) {
      let tempExpenses = this.report.expenses;
      if (this.graphOption === "1") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.orderAmount) !== 0
        );
      }

      if (this.graphOption === "2") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitAmount) !== 0
        );
      }

      if (this.graphOption === "3") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitRate) !== 0
        );
      }

      return tempExpenses.map((item: any) => item.categoryName);
    }
    return [];
  }

  get expenseCategoriesValue() {
    this.graphFormatter = 1;
    if (this.report.expenses) {
      if (this.graphOption === "1") {
        return this.report.expenses
          .filter((item: any) => Number(item.orderAmount) !== 0)
          .map((item: any) => item.orderAmount);
      }

      if (this.graphOption === "2") {
        return this.report.expenses
          .filter((item: any) => Number(item.profitAmount) !== 0)
          .map((item: any) => item.profitAmount);
      }

      if (this.graphOption === "3") {
        this.graphFormatter = 2;
        return this.report.expenses
          .filter((item: any) => Number(item.profitRate) !== 0)
          .map((item: any) => item.profitRate);
      }
    }
    return [];
  }

  get disablePrevMonth() {
    return this.monthIndex === 0;
  }

  get disableNextMonth() {
    return this.monthIndex === this.monthLabelOptions.length - 1;
  }

  get expenseGraphFormatter() {
    return this.graphFormatter;
  }

  movePrevMonth() {
    const item = this.monthLabelOptions[this.monthIndex - 1];
    if (item) {
      this.monthLabel = item.label;
      this.monthIndex -= 1;
      this.search();
    }
  }

  moveNextMonth() {
    const item = this.monthLabelOptions[this.monthIndex + 1];
    if (item) {
      this.monthLabel = item.label;
      this.monthIndex += 1;
      this.search();
    }
  }

  async exportCSV() {
    const response = await getSalesReportCSV({
      ...this.query,
      month: this.monthLabelOptions[this.monthIndex].value,
      projectId: this.projectId
    });

    if (response.file) {
      window.open(response.file);
    }
  }

  isEmptyPieChart() {
    return this.expenseCategoriesValue.every((item: any) => Number(item) === 0);
  }
}
